<template>
	<InquiryListContainer area="superadmin" />
</template>

<script>
	import InquiryListContainer from '@/components/InquiryListContainer.vue'

	export default {
		name: 'InquiryManagementView',
		components: {
			InquiryListContainer
		},
		data() {
			return {

			}
		},
	}
</script>